import { render, staticRenderFns } from "./GenerateInvoiceCardStarter.vue?vue&type=template&id=316e22c8&"
import script from "./GenerateInvoiceCardStarter.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoiceCardStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports